import React from "react";
import Arrow from "../parts/Arrow";

import "../../assets/styles/Separator.scss";
import { RefType } from "../../types";

export interface SeparatorProps {
  classes?: string;
  scrollTo?: RefType;
}

export interface SeparatorState {}

export const Separator = (props: SeparatorProps) => {
  return (
    <section className={`separator ${props.classes || ""}`}>
      <div className="content">
        <div className="d-flex justify-content-center position-relative">
          <div className="line"></div>
          {props.scrollTo && <Arrow scrollTo={props.scrollTo} />}
        </div>
      </div>
    </section>
  );
};

export default Separator;
